import { LicenseInfo } from '@mui/x-license';

export const initMuiXLicense = () => {
    const key = import.meta.env.VITE_MUIX_LICENSE_KEY;
    if (!key) return;
    LicenseInfo.setLicenseKey(key);
};

